/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Found entity with frequency of purchases
 */
export type Gsoa_Recommender_EntitiesBuy = {
    /**
     * Type of entity
     */
    Type?: Gsoa_Recommender_EntitiesBuy.Type;
    /**
     * The number of items purchased over the reference period
     */
    BuyCount?: number;
    /**
     * Warengruppen id entity
     */
    Warengruppen?: number;
    /**
     * Entity identifier
     */
    ID?: string;
    /**
     * Vanr entity
     */
    Vanr?: string;
    /**
     * EAN entity (if more than one EAN is assigned to the entity, then it is selected randomly)
     */
    EAN?: string;
    /**
     * Entity name
     */
    Name?: string;
    /**
     * Last modified date description of entities
     */
    LastChange?: string;
    /**
     * Store availability
     */
    Availability?: string;
};
export namespace Gsoa_Recommender_EntitiesBuy {
    /**
     * Type of entity
     */
    export enum Type {
        PRODUCT = 'Product',
        WARENGRUPPEN = 'Warengruppen',
    }
}

